export default {"src":"/_next/static/media/linkedIn.123e916e.svg","height":32,"width":32};